var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.953 2.802a3.36 3.36 0 0 0-5.85 2.64l.11.879a3.252 3.252 0 0 0 3.223 2.846A3.253 3.253 0 0 0 9.659 6.32l.11-.878a3.364 3.364 0 0 0-.816-2.641ZM16.872 1.85a2.947 2.947 0 0 0-5.144 2.347l.126.883a2.833 2.833 0 0 0 2.791 2.42 2.833 2.833 0 0 0 2.79-2.42l.127-.883a2.945 2.945 0 0 0-.69-2.348ZM19.992 14.254l-.299-2.984A1.668 1.668 0 0 0 18.6 9.863c-2.518-.888-5.07-.914-7.593-.097a4.19 4.19 0 0 1 3.067 3.352l.407 2.446c.062.372.056.737.022 1.094.048 0 .096.006.144.006 1.403 0 2.806-.218 4.2-.655a1.669 1.669 0 0 0 1.145-1.755ZM12.836 15.838l-.407-2.446a2.521 2.521 0 0 0-1.85-2.017c-2.75-.72-5.537-.72-8.287 0a2.523 2.523 0 0 0-1.85 2.017l-.408 2.445a2.493 2.493 0 0 0 1.946 2.861c1.478.311 2.967.466 4.456.466 1.488 0 2.976-.155 4.455-.465a2.493 2.493 0 0 0 1.946-2.862h-.001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.5c21d261a6d68f7fc1c805ce4edb6f2a.svg";
export { ForwardRef as ReactComponent };